import React from 'react';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { ThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';
import { TripTypes } from '@model/common';
import { ImagesResponse, TourTestimonial } from '@model/iceberg';
import { TestId } from '@components/test-ids';
import { TourTestimonialsContainer } from '@components/common/testimonials';
import { BaseHero, ImageContainer } from '@components/common/hero/base/BaseHero';

export interface TestimonialHeroProps {
  image: ImagesResponse;
  destinationName: string;
  testimonials?: Array<TourTestimonial>;
  tripType: TripTypes;
}

const GridContainer: any = styled(Grid)(({ theme }: ThemeProps) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  width: '100%',
  maxWidth: theme.custom.contentSizes.maxContentWidth,
  flex: 1,
  margin: '0 auto',
  height: '100%',
  overflow: 'hidden',
  [mq.medium]: {
    alignItems: 'center'
  }
}));

const StyledHero = styled(BaseHero)({
  [ImageContainer as any]: {
    height: '100%',
    position: 'absolute'
  }
});

export const TourTestimonialHeroComponent = ({
  image,
  testimonials,
  destinationName,
  tripType
}: TestimonialHeroProps) => {
  const imgSrc = image?.images && image.images.length ? image.images[0] : null;

  if (!imgSrc) {
    return null;
  }
  return (
    <StyledHero
      testId={TestId.testimonialHero}
      src={imgSrc}
      renderMain={
        <GridContainer container={true}>
          <Grid item={true} xs={'auto'} sm={1} style={{ padding: 0 }} />
          <Grid item={true} xs={12} sm={12} md={6} lg={6} xl={6}>
            <TourTestimonialsContainer
              timeout={15000}
              testimonials={testimonials}
              destinationName={destinationName}
              tripType={tripType}
            />
          </Grid>
        </GridContainer>
      }
    />
  );
};

export const TourTestimonialHero = withTheme(TourTestimonialHeroComponent);
